export default { options: { label: 'Error Imports' } }
